import type { CoverageStatus, MedicalPlan, YesNo } from "./form";

/**
 * Iterable arrays for the Employee union types — useful for dropdowns, radio
 * groups, validation allow-lists, and tests. The corresponding string literal
 * unions live in `./form.ts`; if either list grows, update both.
 */

/** Coverage statuses offered in the Employee modal. "N/A" / "" are runtime-only and excluded. */
export const COVERAGE_OPTIONS: readonly Extract<CoverageStatus, "Enrolling" | "Waiving" | "Waiting Period">[] =
  ["Enrolling", "Waiving", "Waiting Period"] as const;

/** Canonical medical plan labels — sliced to availablePlans at the call site. */
export const PLAN_LABELS: readonly Exclude<MedicalPlan, "">[] =
  ["Plan 1", "Plan 2", "Plan 3", "Plan 4"] as const;

/** Yes / No options for owner, COBRA, etc. */
export const YES_NO_OPTIONS: readonly Exclude<YesNo, "">[] = ["Yes", "No"] as const;
